import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=4daaee99&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4daaee99')) {
      api.createRecord('4daaee99', component.options)
    } else {
      api.reload('4daaee99', component.options)
    }
    module.hot.accept("./Results.vue?vue&type=template&id=4daaee99&", function () {
      api.rerender('4daaee99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/Results/Results.vue"
export default component.exports